import React from 'react';
import { Link } from 'react-router-dom';

interface Product {
  id: number;
  name: string;
  logoUrl: string; // Placeholder for square logo
  description: string[]; // List of features/descriptions
  minPrice: { amount: number; unit: "booking" | "day"; };
}

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  return (
    <div className="product-card" style={{ border: '1px solid #c3e6cb', borderRadius: '10px', backgroundColor: '#f0fff0', padding: '25px' }}>
      <div className="product-logo">
        {/* Placeholder for the square logo */}
        <img src={product.logoUrl} alt={`${product.name} Logo`} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
      </div>

      <h3>{product.name}</h3>
      
      <div className="product-description">
        <h4>Description:</h4>
        <ul>
          {product.description.map((desc, index) => (
            <li key={index}>{desc}</li>
          ))}
        </ul>
      </div>

      <div className="product-footer">
        <p className="min-price">À partir de : {product.minPrice.amount.toFixed(2)} € / {product.minPrice.unit === "booking" ? "personne" : "jour"}</p>
        {/* The link should go to the contact page and pass product ID */}
        <Link 
          to={`/contact?object=${encodeURIComponent(product.name)}`} 
          className="info-button" 
          style={{ display: 'inline-block', padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', textDecoration: 'none', borderRadius: '8px', cursor: 'pointer' }}
        >
          Se Renseigner
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;